import LeadMagnetHeroTeaser from '@/components/leadmagnet/LeadMagnetHeroTeaser';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/79a8809d-8c54-416a-8e29-3ff1f86d1c7c_compressed_IMG_0086.webp"
          alt="Разработка корпоративных программ обучения сотрудников — Алексей Сивко, BusinessTraining.by"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/65 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center w-full pt-28 md:pt-24">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 md:mb-8 leading-[1.08] tracking-tight max-w-4xl mx-auto">
          Разработка корпоративных программ обучения
        </h1>

        <p className="text-base md:text-lg text-white/85 mb-8 max-w-3xl mx-auto leading-relaxed">
          Не продаём готовые тренинги. Проектируем систему обучения, которая помогает компании достигать конкретных бизнес-целей: увеличить продажи, подготовить руководителей, сократить ошибки, ускорить адаптацию сотрудников и повысить эффективность команды.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <button onClick={() => scrollTo('contact')} className="group bg-teal-600 text-white px-8 py-4 rounded-xl text-base font-semibold hover:bg-teal-500 transition-all duration-300 transform hover:scale-[1.03] whitespace-nowrap cursor-pointer w-full sm:w-auto shadow-lg shadow-teal-600/25 hover:shadow-teal-600/40">
            Заказать разработку программы
            <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
          </button>
          <LeadMagnetHeroTeaser />
        </div>

        <div className="mt-8 flex justify-center">
          <button onClick={() => scrollTo('why-universal-fails')} className="text-white/30 hover:text-white/70 transition-colors cursor-pointer animate-bounce">
            <i className="ri-arrow-down-line text-2xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}